import clsx from 'clsx'
import React, { BaseHTMLAttributes, CSSProperties, FC, PropsWithChildren, ReactNode } from 'react'

import styles from './HeaderWithAccordion.module.scss'

export interface HeaderWithAccordionProps {
  backgroundColor: string
  className?: string
  commonContent?: ReactNode
  style?: CSSProperties
  text?: string | ReactNode
  textColor?: string
  title?: string | ReactNode
}

interface AccordionItemProps {
  className?: string
  defaultChecked?: boolean
  header: ReactNode | string
  headerCollapse?: string
  id: string
  name?: string
  onClick?: BaseHTMLAttributes<HTMLInputElement>['onClick']
}

export const AccordionItem: FC<PropsWithChildren<AccordionItemProps>> = ({ children,
  className,
  defaultChecked,
  header,
  headerCollapse,
  id,
  name,
  onClick }) => (
    <div className={clsx(styles.accordionItem, className)}>
      <input
        className={styles.accordionItemCheckbox}
        defaultChecked={defaultChecked}
        id={id}
        name={name}
        onClick={onClick}
        type={name ? 'radio' : 'checkbox'}
      />
      <div className={clsx(styles.accordionHeaderAndContent, 'headerAndContent')}>
        <label htmlFor={id}>
          <p className={clsx(styles.labelHeader, !headerCollapse && styles.noCollapse)}>{header}</p>
          {headerCollapse && <p className={styles.labelHeaderCollapse}>{headerCollapse}</p>}
          <svg height="100" stroke="black" viewBox="0 0 100 100" width="100" xmlns="http://www.w3.org/2000/svg">
            <path d="M 20 50 H 80" strokeWidth="8" />
            <path d="M 50 20 V 80" strokeWidth="8" />
          </svg>
        </label>
        <div className={styles.accordionContent}>
          {children}
        </div>
      </div>
    </div>
)

export const HeaderWithAccordionItems: FC<PropsWithChildren<HeaderWithAccordionProps>> = ({ backgroundColor,
  children,
  className,
  commonContent,
  style,
  text,
  textColor,
  title }) => {
  const exStyles: CSSProperties = {
    '--backgroundColor': backgroundColor || 'var(--red-500)',
    '--background-color': backgroundColor || 'var(--red-500)',
    '--textColor': textColor || 'var(--white)',
    '--text-color': textColor || 'var(--white)',
    ...style,
  } as CSSProperties

  return (
    <div className={clsx(styles.headerWithAccordion, className)} style={exStyles}>
      {commonContent && (
        <div className={styles.textWrapper}>
          {commonContent}
        </div>
      )}
      {!commonContent && (
        <div className={styles.textWrapper}>
          <h2 className={styles.header}>{title}</h2>
          <p className={styles.text}>{text}</p>
        </div>
      )}
      <div className={styles.accordion}>
        {children}
      </div>
    </div>
  )
}
